import { Link } from 'react-router-dom'
import Translation from '../../Translation/cont/Translation'
import OverlayWrapper from './OverlayWrapper'
import config from '../../../config.json'

const OverlayText = ({titleTransId, text, buttonTextTransId, logoutTextTransId = false, onClickButton}) => (
    <OverlayWrapper>
        <div className='title-large-color text'><Translation id={titleTransId}/></div>

        <p className="text-large-light text">{text}</p>

        <div className="save-button-wrapper">
            <button className="button-save" onClick={()=>onClickButton()}><span className=''><Translation id={buttonTextTransId}/></span></button>            
        </div>

        {logoutTextTransId && <div className="save-button-wrapper">
            <Link className="button-save" to={config.routes.logout.path}><span><Translation id={logoutTextTransId}/></span></Link>
        </div>}
    </OverlayWrapper>
)

export default OverlayText